










































import { Component, Vue } from "vue-property-decorator";
import { mapActions } from "vuex";
import { langKey } from "../domain";

@Component({
  methods: {
    ...mapActions({
      changeLang: "changeLang"
    })
  }
})
export default class LangModal extends Vue {
  changeLang!: (data: langKey) => void;
  dialog = false;

  get lang() {
    return this.$store.state.lang.data;
  }

  get langData() {
    return this.$store.state.lang;
  }

  openCloseDialog() {
    this.dialog = !this.dialog;
  }

  changeLangEvent(langKey: langKey) {
    this.dialog = false;
    this.changeLang(langKey);
    location.reload();
  }
}
